import React from 'react';

// Components
import UploadFilePreview from './UploadFilePreview';

// Types
import { SmtFile } from '../../../../../../../types/Form';
import { Box, HStack, Text, UploadZone, VStack } from '@wegroup/design-system';

interface Props {
  name: string;
  file?: SmtFile;
  Icon: React.ReactElement;
  title: string;
  description?: string;
  error?: string;
  isUploading: boolean;
  handleChange: (arg0?: SmtFile) => void;
  clearFile: (arg0: string) => void;
}

const UploadForm: React.FC<React.PropsWithChildren<Props>> = ({
  name,
  file,
  Icon,
  title,
  description,
  error,
  isUploading,
  handleChange,
  clearFile,
}) => {
  const toSmtFile = (file: File) => {
    if (!file) return;
    return {
      file: new Blob([file], { type: file.type }),
      key: name,
      filename: file.name,
      size: file.size,
      filetype: file.type,
    } as SmtFile;
  };

  return (
    <HStack maxW="600px" w="100%" spacing={{ base: '0', mobileL: '6' }}>
      <Box
        display={{ base: 'none', mobileL: 'block' }}
        w="35%"
        sx={{
          '> svg': {
            height: '100%',
            width: '100%',
          },
        }}
      >
        {Icon}
      </Box>
      <VStack spacing="2" align="stretch" w="100%">
        <Text
          as="h4"
          textStyle={{ base: 'h6Headline', laptop: 'h4Headline' }}
          fontWeight="500"
        >
          {title}
        </Text>
        {description && <Text textStyle="normalBody">{description}</Text>}
        {file ? (
          <UploadFilePreview file={file} onRemove={clearFile} />
        ) : (
          <UploadZone
            onFilesAccepted={(file: File) => handleChange(toSmtFile(file))}
            isLoading={isUploading}
            accept={['.png', '.jpeg', '.jpg', '.pdf']}
            isSmall
          />
        )}

        {error && (
          <Text color="danger.main" textAlign="right">
            {error}
          </Text>
        )}
      </VStack>
    </HStack>
  );
};

export default UploadForm;
